import { HintComponent } from 'legacy/lut/components/widgets/public/partner360/HintComponent'
import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { selectTranslationMode } from 'cng-common/features/translations/selectors'

import styles from './FieldLabel.module.scss'

interface IFieldLabelProps {
  labelTranslation: string
  fYear?: number
}

export const FieldLabel: FC<IFieldLabelProps> = ({ labelTranslation, fYear }) => {
  const translationMode = useSelector(selectTranslationMode)

  const fy = useMemo(() => (fYear ? String(fYear % 100) : ''), [fYear])
  const hintTranslation = useMemo(() => labelTranslation.concat('-hint'), [labelTranslation])

  if (translationMode === 'edit') {
    return (
      <>
        <Translation
          text={labelTranslation}
          replaceParams={[{ key: '{fy}', value: fy }]}
          actionsInside
        />
        <Translation
          text={hintTranslation}
          replaceParams={[{ key: '{fy}', value: fy }]}
          actionsInside
        />
      </>
    )
  }

  return (
    <div className={styles.root}>
      <HintComponent
        text={hintTranslation}
        className={styles.hint}
        iconWrapStyle={styles.hint__icon}
        replaceParams={[{ key: '{fy}', value: fy }]}
      />
      <div className={styles.text}>
        <Translation
          text={labelTranslation}
          replaceParams={[{ key: '{fy}', value: fy }]}
          actionsInside
        />
      </div>
    </div>
  )
}
